/**
 * Delivery Audit Service
 *
 * Read-only API for delivery tracking and click analytics.
 */

import apiClient from './api';

/**
 * Get paginated list of deliveries with optional filters.
 */
export const getDeliveries = async (params = {}) => {
  const {
    page = 1,
    pageSize = 50,
    reportName = '',
    recipientEmail = '',
    status = '',
    deliveryType = '',
    search = '',
    daysBack = 7
  } = params;

  const response = await apiClient.get('/delivery-audit', {
    params: {
      page,
      page_size: pageSize,
      report_name: reportName || undefined,
      recipient_email: recipientEmail || undefined,
      status: status || undefined,
      delivery_type: deliveryType || undefined,
      search: search || undefined,
      days_back: daysBack
    }
  });

  const data = response.data?.data || response.data;
  return {
    deliveries: data.deliveries || [],
    pagination: data.pagination || { page, page_size: pageSize, total: 0, total_pages: 1 }
  };
};

/**
 * Get aggregate delivery and click statistics.
 */
export const getDeliveryStats = async (daysBack = 7) => {
  const response = await apiClient.get('/delivery-audit/stats', {
    params: { days_back: daysBack }
  });
  return response.data?.data || response.data;
};

/**
 * Get deliveries for a specific report.
 */
export const getReportDeliveries = async (reportName) => {
  const response = await apiClient.get(`/delivery-audit/report/${encodeURIComponent(reportName)}`);
  return response.data?.data || response.data;
};

/**
 * Get deliveries for a specific recipient.
 */
export const getRecipientDeliveries = async (email) => {
  const response = await apiClient.get(`/delivery-audit/recipient/${encodeURIComponent(email)}`);
  return response.data?.data || response.data;
};
